import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import { ApiClientError } from '~/ApiClient';
import Price from '~/libs/Price';

import { FinalCalculation } from './FinalCalculation';
import { mapError } from './mapError';

export interface RawFinalCalculation {
	readonly emptyResultReason: ApiClientError[];
	readonly priceDropPercents: number | null;
	readonly ercPriceDropPercents: number | null;
	readonly referencedProduct: {
		readonly id: string;
		readonly dataSource: RawDataSource;
		readonly currentExFactoryPrice: {
			readonly currency: string;
			readonly value: string;
		} | null;
	} | null;
	readonly threeLowestPricesAvg: {
		readonly currency: string;
		readonly value: string;
		readonly ercPrice: {
			readonly currency: string;
			readonly value: string;
		};
		readonly fromProducts: Array<{
			readonly id: string;
			readonly dataSource: RawDataSource;
			readonly samePackageSize: boolean;
		}>;
		readonly ercFromProducts: Array<{
			readonly id: string;
			readonly dataSource: RawDataSource;
			readonly samePackageSize: boolean;
		}>;
	} | null;
}

export const mapFinalCalculation = (finalCalculation: RawFinalCalculation) => {
	return new FinalCalculation(
		finalCalculation.emptyResultReason.map(mapError),
		finalCalculation.priceDropPercents,
		finalCalculation.ercPriceDropPercents,
		finalCalculation.referencedProduct !== null
			? {
					...finalCalculation.referencedProduct,
					dataSource: mapDataSource(finalCalculation.referencedProduct.dataSource),
					currentExFactoryPrice:
						finalCalculation.referencedProduct.currentExFactoryPrice !== null
							? new Price(
									finalCalculation.referencedProduct.currentExFactoryPrice.value,
									finalCalculation.referencedProduct.currentExFactoryPrice.currency
							  )
							: null,
			  }
			: null,
		finalCalculation.threeLowestPricesAvg !== null
			? {
					price: new Price(finalCalculation.threeLowestPricesAvg.value, finalCalculation.threeLowestPricesAvg.currency),
					ercPrice: new Price(
						finalCalculation.threeLowestPricesAvg.ercPrice.value,
						finalCalculation.threeLowestPricesAvg.ercPrice.currency
					),
					fromProducts: finalCalculation.threeLowestPricesAvg.fromProducts.map((product) => ({
						...product,
						dataSource: mapDataSource(product.dataSource),
					})),
					ercFromProducts: finalCalculation.threeLowestPricesAvg.ercFromProducts.map((product) => ({
						...product,
						dataSource: mapDataSource(product.dataSource),
					})),
			  }
			: null
	);
};
